import { useEffect, useRef } from "react";
import useTotals from "../hooks/use-totals";
import { isNumerical } from "../lib/utils";
import { useCropperStore } from "../store/cropper/cropper-store";
import { useProduct } from "../store/product";
import l10n, { media_l10n } from "../lib/l10n";

const sqmt_price = parseFloat( media_l10n.sqmt_price );
const sold_per_pice = media_l10n.per_piece;
const sqmt = parseFloat( media_l10n.sqmt );
const template = media_l10n.template;
const intlConfig = { 
  // trailingZeroDisplay: 'stripIfInteger',
  minimumFractionDigits: 2 
};

function ProductPage() {
  const { getPricePerSquareMeter } = useTotals();
  const media = useCropperStore(s => s.preset.media);
  const product = useProduct(s => s.product);
  const wcPrice = useRef(document.querySelector('.summary.entry-summary .price'));

  function formatPrice(price) {
    return new Intl.NumberFormat(l10n.lang, intlConfig).format(price);
  }

  function priceTemplate(price) {
    return template.format
      .replace(/\%1\$s/, template.currency)
      .replace(/\%2\$s/, price);
  }

  useEffect(() => {
    if  (wcPrice.current) {
      const pricePerSqmt = getPricePerSquareMeter();
      const price = pricePerSqmt * ((product.dimension_width / 100) * product.dimension_height) / 100;
      if (isNumerical(price)) {
        const formattedPrice = formatPrice(price);
        const priceHTML = priceTemplate(formattedPrice);
        wcPrice.current.innerHTML = priceHTML;
      }
    }
  }, [media]);
}

export default ProductPage;